import { Component, Input, ViewChild, OnChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatAccordion } from '@angular/material/expansion';
import { ContactDialogComponent } from '../../../common/contact-dialog/components/contact-dialog/contact-dialog.component';
import { IFundraiser } from '../../../fundraiser/models/fundraiser.model';
import { EventsService, VariablesService } from '../../../shared/services';
declare var require: any;
interface IFaqs {
  title: string;
  desc: string;
  contact?: string;
}
@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent implements OnChanges {

  @Input() fundraiser: IFundraiser;
  @Input() beneficiary;
  @Input() page;
  @Input() cls;
  @Input() type = 'v1';
  @Input() config;
  faqs1: IFaqs[];
  faqs2: IFaqs[];
  step1 = 0;
  step2 = 0;
  // expHeight = '60px';
  expHeight = 'auto';
  @ViewChild('accordion1') accordion1: MatAccordion;
  @ViewChild('accordion2') accordion2: MatAccordion;
  constructor(
    public dialog: MatDialog,
    public vars: VariablesService,
    public events: EventsService,
  ) { }

  ngOnChanges() {
    if (this.page === 'story' || this.page === 'story-v2') {
      this.faqs1 = require('../objects/faqs1.json');
      this.faqs2 = require('../objects/faqs2.json');
      if (this.vars.fundraiser?.is_multi_patient_campaign) {
        const mpFaq = require('../objects/multipatient-faqs.json');
        this.faqs1 = [...this.faqs1, ...this.faqs2, ...mpFaq];
        this.faqs2 = [];
        const splitPt = Math.ceil(this.faqs1.length/2);
        for (let i = splitPt; i < this.faqs1.length; i++) {
          this.faqs2.push(this.faqs1[i]);
        }
        this.faqs1 = this.faqs1.slice(0, splitPt);
      }
    } else if (this.page === 'portfolio') {
      this.faqs1 = require('../objects/portfolio_faqs1.json');
      this.faqs2 = require('../objects/portfolio_faqs2.json');
    } else if (this.page === 'non_medical') {
      this.faqs1 = require('../objects/non_medical_story_faqs1.json');
      this.faqs2 = require('../objects/non_medical_story_faqs2.json');
    } else if (this.page === 'fundraiser') {
      this.faqs1 = require('../objects/fundraiser.json');
    }
    if (this.vars.showKCart) {
      this.faqs1 = require('../objects/product-faqs.json');
      this.faqs2 = [];
      const splitPt = Math.ceil(this.faqs1.length/2);
      for (let i = splitPt; i < this.faqs1.length; i++) {
        this.faqs2.push(this.faqs1[i]);
      }
      this.faqs1 = this.faqs1.slice(0, splitPt);
    }
  }
  /**set the steps of the accordion */
  setStep1(index) {
    this.step1 = index;
    if (this.accordion2) { this.accordion2.closeAll(); }
  }
  setStep2(index) {
    this.step2 = index;
    this.accordion1.closeAll();
  }

  /**Open contact dialog */
  openDialog() {
    this.events.sendSystemEvent({
      eventName: 'contact_beneficiary',
      event_type: 'campaign',
      page_name: this.vars.pageName,
      event_type_id: this.vars?.fundraiser?.id,
    }).subscribe(_ => _);
    this.dialog.open(ContactDialogComponent, {
      data: {
        title: this.beneficiary,
        id: this.fundraiser?.id,
        contact: this.fundraiser?.non_medical ? 'ngo' : ''
      },
      width: '100vw',
      maxWidth: '590px',
      maxHeight: '98vh',
      panelClass: ['round-dialog', 'contact-modal']
    });
  }

}
